export default "__VITE_ASSET__79fbd34b__"